<template>
  <div class="home" v-loading="loading">
    <div class="slide-one"></div>
    <div class="slide-two">
      <div>魅乐科技致力打造将技术，资源，人才融为一体，面向未来的社群新零售服务平台
        让更多人借助平台的支持，为用户创造更大价值，获得应有的尊重和回报，成就事业梦想。</div>
      <div>共创 共享 共生 共赢</div>
      <div class="detail">
        <div>2024年 项目实际生态赛闭环；</div>
        <div>2018年 归零，基于业务需注重启项目研发；</div>
        <div>2017年 项目研发失败，解散技术研发团队；</div>
        <div>2014年 确立转做平台发展，启动自研技术开发；</div>
        <div>2011年 杭州魅乐科技有限公司成立；</div>
        <div>2004年 从835元开始创业 </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoIn",
  components: {

  },
  data() {
    return {
    };
  },
  created() { },
  // 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
  computed: {

  },
  mounted() {
    this.$http
      .all([
        this.$http.get("Cases/GetCasesAll"),
        this.$http.get(`News?type=1&num=3`)
      ])
      .then(
        this.$http.spread((responseCases, responseNews) => {
          this.caseList = responseCases.data;
          this.newsList = responseNews.data;
          this.loading = false;
        })
      );
  }
};
</script>

<style src="../style/shared.css"></style>

<style lang="scss" scoped>
.slide-one {
  background: url(../assets/img/home_top.jpg) no-repeat center;
  background-size: cover;
  height: 418px;
  // width: 1440px;
}

.slide-two {

  margin: 40px;

  height: 400px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;

  .detail div {
    margin: 10px 0;
  }

}
</style>